import * as React from 'react';

import c4bLogo from 'images/ent-website/c4b-logo.svg';

import _t from 'i18n!nls/ent-website';

function C4BLogo() {
  return <img src={c4bLogo} width={240} alt={_t('Coursera for Business')} />;
}

export default C4BLogo;
